var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhoneStroked = function SvgPhoneStroked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M20.964 16.477v2.71a1.807 1.807 0 0 1-1.97 1.806A17.9 17.9 0 0 1 11.2 18.22a17.6 17.6 0 0 1-5.42-5.42 17.9 17.9 0 0 1-2.773-7.83A1.807 1.807 0 0 1 4.805 3h2.71A1.806 1.806 0 0 1 9.32 4.554c.114.867.326 1.718.632 2.538a1.81 1.81 0 0 1-.406 1.906L8.4 10.145a14.45 14.45 0 0 0 5.42 5.42l1.146-1.148a1.81 1.81 0 0 1 1.906-.406c.82.305 1.671.518 2.538.632a1.806 1.806 0 0 1 1.554 1.834"
  })));
};
export default SvgPhoneStroked;